import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

//Custom Components

import Home from "../pages/home";
import Header from "../components/Layout/Header";
import About from "../pages/about";
import Team from "../pages/team";
import TeamDetails from "../pages/team/team-details";
import Blog from "../pages/blog";
import BlogDetails from "../pages/blog/blog-details";
import Services from "../pages/service";
import ServiceOne from "../pages/service/service-1";
import ServiceTwo from "../pages/service/service-2";
import ServiceThree from "../pages/service/service-3";
import ServiceDetails from "../pages/service/service-details";
import SoftwareDevelopment from "../pages/service/software-development";
import WebDevelopment from "../pages/service/web-development";
import AnalyticSolutions from "../pages/service/analytic-solutions";
import cloudAndDevops from "../pages/service/cloud-and-devops";
import ProjectDesign from "../pages/service/project-design";
import DataCenter from "../pages/service/data-center";
import CaseStudtyStyleOne from "../pages/case-study/style-1";
import CaseStudtyStyleTwo from "../pages/case-study/style-2";
import CaseStudtyStyleThree from "../pages/case-study/style-3";
import CaseStudtyStyleFour from "../pages/case-study/style-4";
import CaseStudtyStyleFive from "../pages/case-study/style-5";
import CaseStudtyStyleSix from "../pages/case-study/style-6";
import CaseStudtyStyleSeven from "../pages/case-study/style-7";
import Faq from "../pages/faq";
import Pricing from "../pages/pricing";
import Contact from "../pages/contact";
import Error from "../pages/404";
import LoadTop from "../components/Common/ScrollTop/LoadTop";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  setBanner,
  setPage,
  setService,
  setTeam,
  setTestimonial,
} from "../store/slice";
import Loader from "../Loader";
import axios from "axios";
import { BASE_URL } from "../Service";

const App = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [bannerRes, pageRes, serviceRes, teamRes, testimonialRes] =
          await Promise.all([
            axios.get(`${BASE_URL}/api/v1/banner`),
            axios.get(`${BASE_URL}/api/v1/page`),
            axios.get(`${BASE_URL}/api/v1/service`),
            axios.get(`${BASE_URL}/api/v1/team`),
            axios.get(`${BASE_URL}/api/v1/testimonials`),
          ]);

        if (bannerRes.data.success) dispatch(setBanner(bannerRes.data.data));
        if (pageRes.data.success) dispatch(setPage(pageRes.data));
        if (serviceRes.data.success) dispatch(setService(serviceRes.data.data));
        if (teamRes.data.success) dispatch(setTeam(teamRes.data.data));
        if (testimonialRes.data.success)
          dispatch(setTestimonial(testimonialRes.data.data));
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data: ", error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="App">
      <Router>
        <Header parentMenu="home" secondParentMenu="multipage" activeMenu="" />
        <LoadTop />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/home" component={Home} />

          <Route path="/about" component={About} />
          <Route path="/service" exact component={Services} />
          <Route path="/service/service-1" component={ServiceOne} />
          <Route path="/service/service-2" component={ServiceTwo} />
          <Route path="/service/service-3" component={ServiceThree} />
          <Route path="/service/service-details" component={ServiceDetails} />
          <Route
            path="/service/software-development"
            component={SoftwareDevelopment}
          />
          <Route path="/service/web-development" component={WebDevelopment} />
          <Route
            path="/service/analytic-solutions"
            component={AnalyticSolutions}
          />
          <Route path="/service/cloud-and-devops" component={cloudAndDevops} />
          <Route path="/service/project-design" component={ProjectDesign} />
          <Route path="/service/data-center" component={DataCenter} />
          <Route path="/team" exact component={Team} />
          <Route path="/team/team-details" component={TeamDetails} />
          <Route path="/blog" exact component={Blog} />
          <Route path="/blog/blog-details" component={BlogDetails} />
          <Route path="/case-study/style-1" component={CaseStudtyStyleOne} />
          <Route path="/case-study/style-2" component={CaseStudtyStyleTwo} />
          <Route path="/case-study/style-3" component={CaseStudtyStyleThree} />
          <Route path="/case-study/style-4" component={CaseStudtyStyleFour} />
          <Route path="/case-study/style-5" component={CaseStudtyStyleFive} />
          <Route path="/case-study/style-6" component={CaseStudtyStyleSix} />
          <Route path="/case-study/style-7" component={CaseStudtyStyleSeven} />
          <Route path="/faq" component={Faq} />
          <Route path="/pricing" component={Pricing} />
          <Route path="/contact" component={Contact} />
          <Route component={Error} />
        </Switch>
      </Router>
    </div>
  );
};

export default App;
